import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import Select, { components } from "react-select";

const DropDownCustom = ({
  selectedValue,
  handleChanges,
  options,
  isSearchable,
  label,
  placeholder,
  isAligned,
  isClient,
  onFocus,
  onBlur,
}) => {
  const CustomInput = (props) => {
    return (
      <components.Input
        {...props}
        innerRef={(ref) => {
          if (ref) {
            ref.style.outline = "none";
            ref.style.boxShadow = "none";
          }
          if (props.innerRef) props.innerRef(ref);
        }}
        className="text-gray-700 text-sm px-1 focus:outline-none"
      />
    );
  };
  const CustomControl = (props) => {
    const isOpen = props.selectProps.menuIsOpen;
    return (
      <components.Control {...props}>
        {isSearchable && isOpen && (
          <div className="pl-2 pr-1 text-gray-400">
            <FiSearch size={16} />
          </div>
        )}
        {props.children}
      </components.Control>
    );
  };
  return isAligned ? (
    <div className="relative w-[250px]  sm:w-full ">
      <div
        className={`relative top-3 left-4 bg-white px-1 w-[150px] z-[8] ${
          isClient ? "mt-[-24px]" : "mt-[-22px]"
        }`}
      >
        <label className="text-sm font-medium text-gray-600">{label}</label>
      </div>
      {/* </div> */}
      <Select
        value={selectedValue}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleChanges}
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        styles={{
          control: (provided) => ({
            ...provided,
            borderRadius: "0.4rem",
            padding: "0.11rem",
            borderColor: "#d1d5db",
            boxShadow: "none",
            width: "100%",
            minHeight: "35px",
            "&:hover": {
              borderColor: "#361D32",
            },
          }),
          menu: (provided) => ({
            ...provided,
            width: "100%",
            zIndex: 10,
            justifyContent: "center",
            marginLeft: "1%",
            fontSize: "14px",
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#361D32"
              : state.isFocused
              ? "lightgrey"
              : "white",
            color: state.isSelected ? "white" : "black",
            borderRadius: "0.25rem",
            marginBottom: "0.25rem",
          }),
        }}
      />
    </div>
  ) : (
    <div>
      <div
        className={`relative top-3 left-4 bg-white px-1 w-[150px] z-[8] ${
          isClient ? "mt-[-24px]" : ""
        }`}
      >
        <label className="text-sm font-medium text-gray-600">{label}</label>
      </div>
      <Select
        components={{
          Control: CustomControl,
          Input: CustomInput,
        }}
        value={selectedValue}
        onChange={handleChanges}
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        styles={{
          input: (base) => ({
            ...base,
            margin: 0,
            padding: "0px",
            color: "#111827",
            fontSize: "0.875rem",
            outline: "none",
            boxShadow: "none",
          }),

          control: (provided) => ({
            ...provided,

            borderRadius: "0.4rem",
            padding: "0.5rem",
            borderColor: "#d1d5db",
            boxShadow: "none",
            fontSize: "14px",
            marginTop: -3,
            "&:hover": {
              borderColor: "#361D32",
            },
          }),
          menu: (provided) => ({
            ...provided,
            width: "100%",
            zIndex: 10,
            justifyContent: "center",
            marginLeft: "1%",
            fontSize: "14px",
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#361D32"
              : state.isFocused
              ? "lightgrey"
              : "white",
            color: state.isSelected ? "white" : "black",
            width: "96%",
            justifySelf: "center",
            borderRadius: "0.25rem",
            marginBottom: "0.25rem",
            fontSize: "14px",
          }),
        }}
      />
    </div>
  );
};

export default DropDownCustom;
